// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToListModalStyles } from "@insite/content-library/Components/AddToListModal";
import getColor from "@insite/mobius/utilities/getColor";
import { MediaQuery } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

addToListModalStyles.modal = {
    size: 600,
    cssOverrides: {
        modalBody: css`
            overflow-y: visible;
        `,
        modalTitle: css`
            h4 {
                font-size: 32px;
                letter-spacing: 0;
                line-height: 35px;
                padding: 0;
                margin-bottom: 0;
            }
            padding: 40px 40px 16px;
            background: ${getColor("common.white")};
        `,
        modalContent: css`
            padding: 20px;
            background: ${getColor("common.white")};
            overflow-y: visible;
            > div:last-child[class^="sc-"] {
                flex-direction: column;
            }
        `,
    },
};

addToListModalStyles.buttonsWrapper = {
    css: css`
        padding: 20px 40px;
        margin: 40px -40px -20px;
        background-color: ${getColor("common.ui3")};
        display: flex;

        ${MediaQuery.lte("sm")} {
            flex-direction: column;
        }
    `,
};

addToListModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        order: 2;
    `,
};

addToListModalStyles.addButton = {
    css: css`
        order: 1;
        margin-right: 10px;
        ${MediaQuery.lte("sm")} {
            width: 100%;
            margin-right: 0;
            margin-bottom: 10px;
        }
    `,
};
